(() => {
  const sections = document.querySelectorAll('[data-digi-about-hero]');

  if (!sections.length) return;

  sections.forEach((section) => {
    const slider = section.querySelector('[data-digi-about-hero-slider]');
    const slides = section.querySelectorAll('[data-digi-about-hero-slide]');

    if (!slider || slides.length <= 1) return;

    let currentIndex = 0;
    const intervalTime = 4500;

    function showSlide(index) {
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === index);
      });
    }

    setInterval(() => {
      currentIndex = currentIndex + 1;

      if (currentIndex >= slides.length) {
        currentIndex = 0;
      }

      showSlide(currentIndex);
    }, intervalTime);
  });
})();
